import { render, staticRenderFns } from "./RADIOBUTTONS.vue?vue&type=template&id=3b5175f9&scoped=true&"
import script from "./RADIOBUTTONS.vue?vue&type=script&lang=js&"
export * from "./RADIOBUTTONS.vue?vue&type=script&lang=js&"
import style0 from "./RADIOBUTTONS.vue?vue&type=style&index=0&id=3b5175f9&lang=scss&scoped=true&"
import style1 from "./RADIOBUTTONS.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5175f9",
  null
  
)

export default component.exports